// Core client creation and configuration
export { createApiClient } from './client.js';
export { getBaseUrl } from './base-url.js';
// Auth errors
export { SessionExpiredError, isSessionExpiredError, SESSION_EXPIRED_ERROR_NAME, } from './errors.js';
export { handleSessionExpired } from './session-expiry.js';
// Environment safety utilities
export { validateEnvironmentSafety, checkEnvironmentSafety, logEnvironmentSafetyResult, } from './environment-safety.js';
// Auth module
export { createAuthModule } from './auth.js';
// Generic API module
export { createApiModule } from './api.js';
// Potentially a main factory function to create a fully-fledged client with all modules
import { createApiClient as createClientInternal } from './client.js';
import { createAuthModule as createAuthModuleInternal } from './auth.js';
import { createApiModule as createApiModuleInternal } from './api.js';
/**
 * Creates a full Tiny Health API client instance with auth and generic API methods.
 * @param config The API client configuration.
 * @returns An instance of the Tiny Health API client.
 */
export function createTinyHealthApiClient(config) {
    const { request } = createClientInternal(config);
    const auth = createAuthModuleInternal(request);
    const api = createApiModuleInternal(request);
    return {
        request, // Expose the core request function if direct access is needed
        auth,
        api,
        // You can also directly spread methods if preferred, e.g.,
        // ...auth,
        // ...api,
        // However, namespacing under 'auth' and 'api' is often clearer.
    };
}
// Context for providing API client configuration
export { ApiClientProvider, useApiClient } from './context/ApiClientContext.js';
// Pagination utilities
export { buildTableQueryString, parsePaginatedResponse, createTableQueryParams, } from './pagination.js';
// Hooks
export { usePaginatedQuery, getPaginatedQueryKey, } from './hooks/index.js';
//# sourceMappingURL=index.js.map